/* eslint-disable max-lines */
import {
    PriceDropQueryParameters,
    QueryOrdersBelowControlPriceVo,
    ErpDisOrderRsp,
    ErpDisOrderParam,
    ListAuthShopsUsingGetParams,
    GylErpShopInfo8,
    QueryUserAuthShopsUsingGetParams,
    ShopVo,
    ExpressParam,
    ValidateExpressSettingParam,
    RecalculationFreightParam,
    AuditOrPushOrdersParam,
    AsyncProcessingResultVoAuditOrPushOrdersResult,
    CreateAsyncTaskResult,
    AsyncProcessingResultVoObject,
    AssignSupplierParam,
    AssignSupplierForOrderParam,
    OrderTagListUsingGetParams,
    ConvertDisOrderParam,
    ConvertAndSetSupDisOrderParam,
    ConvertAndSetSupDisOrderV3Param,
    ConvertAndSetSupDisOrderVo,
    IsAuthShopUsingGetParams,
    ReceiveTimeOutParam,
    DelGoodsParam,
    SplitOrderParam,
    CountUsingGet1Params,
    QueryOrderLogUsingGet1Params,
    QueryOrderActionsVo,
    OrderRevokeParam,
    MergeDisOrderRsp,
    CancelOrderParam,
    QueryOrderItemPickableUsingGetParams,
    OrderItemPickableVo,
    ItemLinkParam,
    OrderAmountSplitRulesParam,
    SaveOrderAmountSplitRulesVo,
    SingleSplitOrderV2Param,
    UpdateCompanyTagParam,
    SetOrderTagParam,
    SetOrderFlagParam,
    GylOrder,
    OrderCreateVo,
    BatchAddGiftVo,
    SyncOrdersBySoIdsParam,
    DownloadOrderVo,
    SyncOrdersByTimeRangeParam,
    ErpExchangeGoodsByMultipleParam,
    ExchangeGoodsByMultipleVo,
    BatchSplitCombineParam,
    BatchSplitCombineVo,
    SplitCombineParam,
    SplitCombineVo,
    QueryOrderLogisticsFreightUsingGet1Params,
    OrderFreightQueryVo,
    OrderSupLogisticsParam,
    SupplierLogisticsVo,
    DisOrderLogisticsParam,
    QueryErpOrderNotesVo,
    SaveErpOrderNotesParam,
    SaveErpOrderNotesVo,
    BatchSetOrderNotesParam,
    BatchSetOrderNotesVo,
    QueryOrderSplitRulesVo,
    SplitOrdersAccordingToRulesParam,
    SplitOrdersAccordingToRulesVo,
    QueryUnprofitableOrderUsingGet1Params,
    ErpDisOrder,
    LockTheOrderParam,
    LockAndUnlockTheOrderVo,
    UnlockTheOrderParam,
    OrderLossMakingConfig,
    QueryDeliveryStatusParam,
    ExpressDeliveryStatusVo,
    QueryExpressDeliverySuspensionStatusParam,
    ExpressDeliverySuspensionStatusVo,
    BatchExchangeGoodsParam,
    BatchExchangeGoodsVo,
    QueryOrderIdByItemCodeParam,
    QueryOrderIdByItemCodeVo,
    OrderProductPricingStrategyParam,
    OrderProductPricingStrategyVo,
    GenerateSupSettlementParam,
    ChannelSettlementAmountParam,
    ErpDisOrderAmt,
    QueryPriceChangeLogUsingGetParams,
    OrderSettlementPriceChangeLog,
    GetOrderIdsAfterRedirectUsingGetParams,
    OrderConfigVo,
    EditOrderConfigParam,
    UrgeDispatchGoodsParam,
    UrgeDispatchGoodsVo,
    ListUrgeSendParam,
    UrgeSendVo,
    OrderItemDrpExtendParam,
    OrderItemDrpExtendVo,
    BatchDelGoodsParam,
    QueryMultiSuppliersInfoUsingGetParams,
    GetSplitOrderIdUsingGetParams,
    ItemMultiSupplierInfoVo,
    QueryLogisticsAndFreightParam,
    QueryLogisticsAndFreightVo,
    BatchSetOrBindingExpressParam,
    AsyncQueryLogisticsAndFreightVo,
    AsyncResultParams,
    AsyncProcessingResultVoQueryLogisticsAndFreightVo
} from '@servicesTypings/companyRequest'
import {
    DisInnerOrderListParam,
    DisInnerOrderListView,
    InnerOrderListParam,
    DisInnerOrderGoodsView,
    OrderDecryptionParam,
    DecryptionVo,
    QueryPendingSettlementOrders
} from '@servicesTypings/towerRequest'
import {
    Logistics,
    QueryMySupplierForOrderUsingGetParams,
    OrderSupplierVo,
    QueryMySupplierOptionsUsingGetParams,
    QueryMySupplierByOptionalsUsingGetParams,
    QueryMyChannelOptionsUsingGetParams,
    SimpleMyChannelVo,
    AllowSplitOrderNumVo
} from '@servicesTypings/drpRequest'
import { QueryOrderDto, PushResultVo } from '@servicesTypings/payRequest'
import {
    QueryErpGoodsParam,
    ErpGoodsVO,
    SkuBindMapQueryParam,
    SkuBindMap,
    ShopItemBindParam,
    OnlineItemBindVo,
    OrderDrpGoodsVo,
    OrderDrpGoodsInfo,
    ErpSupplierItemParam,
    ErpSupplierItemVo,
    QuerySupplierSkuLimitUsingGetParams
} from '@servicesTypings/goodsRequest'
import { ItemCodesParam, ItemCodesSupplierInfoVo } from '@servicesTypings/towerDrpRequest'

import {
    companyRequest,
    goodsRequest,
    printerRequest,
    towerRequest,
    drpRequest,
    payRequest,
    towerDrpRequest,
    towerPrinterRequest
} from '@/utils/request'

// 获取分销订单列表
/**
 * 分销订单列表
 */
export function queryErpDisOrders(data: DisInnerOrderListParam): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/innerOrder/getErpDisOrders', { data })
}

// 获取所有订单列表
/**
 * 订单列表
 */
export function queryErpOrders(data: InnerOrderListParam): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/order/list', { data })
}

// 获取是否有分销订单
/**
 * 是否有分销订单
 */
export function hasDisOrderApi(data: DisInnerOrderListParam): API.Res<boolean> {
    return towerRequest.post('/innerOrder/hasDisOrder', { data })
}

// 获取是否有自主订单
/**
 * 是否有普通订单
 */
export function hasNormalOrderApi(data: DisInnerOrderListParam): API.Res<boolean> {
    return towerRequest.post('/innerOrder/hasNormalOrder', { data })
}

// 首页代发订单统计
export function countHomepageDropShipOrders() {
    return companyRequest.get('/order/statistics/countHomepageDropShipOrders')
}
// 清除发货快超时订单缓存
export function clearDisOrderCountStatisticsCache(params) {
    return companyRequest.get('/order/cache/manage/clearDisOrderCountStatisticsCache', { params })
}

// 查询渠道测已绑定快递
/**
 * 渠道获取已绑定的快递公司
 */
export function fetchBindListApi(): API.Res<Logistics[]> {
    return drpRequest.get('/channel/logistics/list')
}

// 查询供应商侧已绑定快递
/**
 * 供应商获取已绑定的快递公司
 */
export function fetchSupplierBindList(): API.Res<Logistics[]> {
    return drpRequest.get('/supplier/logistics/list')
}

// 批量转正常单
/**
 * 转正常单
 */
export function batchTransformNormal(data: string[]): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchTransformNormal', { data })
}

// 根据查询条件统计快递异常的订单数量
/**
 * 根据查询条件统计快递异常的订单数量 (转换包含中文无法完全转换)
 */
export function countExceptionalOrdersByCriteriaApi(data: any): API.Res<any> {
    return companyRequest.post('/order/logistics/status/countExceptionalOrdersByCriteria', { data })
}

// 按条件批量取消供应商库存不足异常
/**
 * 按条件批量取消供应商库存不足异常
 */
export function cancelSupplierInsufficientStockExceptionApi(data: ErpDisOrderParam): API.Res<boolean> {
    return companyRequest.post('/order/operate/cancelSupplierInsufficientStockException', { data })
}

// 批量匹配低价物流
/**
 * 批量匹配低价物流 (转换包含中文无法完全转换)
 */
export function batchMatchLowCostLogisticsApi(data: any): API.Res<any> {
    return companyRequest.post('/order/operate/batchMatchLowCostLogistics', { data })
}

// 我的供应商列表
/**
 * 查询我的供应商(分销订单用)
 */
export function queryMySupplierForOrder(params: QueryMySupplierForOrderUsingGetParams): API.Res<OrderSupplierVo[]> {
    return drpRequest.get('/mySupplier/queryMySupplierForOrder', { params })
}

// 我的供应商列表(已合作的)
/**
 * 查询我的供应商
 */
export function queryMySupplierOptions(params: QueryMySupplierOptionsUsingGetParams): API.Res<OrderSupplierVo[]> {
    return drpRequest.get('/mySupplier/queryMySupplierOptions', { params })
}

// 我的供应商列表(已合作的) --- 去掉大店
/**
 * 查询我的供应商下拉列表使用(隐藏大店商家)
 */
export function queryMySupplierByOptionals(
    params: QueryMySupplierByOptionalsUsingGetParams
): API.Res<OrderSupplierVo[]> {
    return drpRequest.get('/partner/channel/queryMySupplierByOptionals', { params })
}

// 我的分销商下拉列表(用于分销资金明细)
/**
 * 查询我的分销商
 */
export function queryMyChannelOptions(params: QueryMyChannelOptionsUsingGetParams): API.Res<SimpleMyChannelVo[]> {
    return drpRequest.get('/partner/supplier/queryMyChannelOptions', { params })
}

// 供应商列表(合作中)全部，不分页
/**
 * 查询我的供应商(转分销订单下拉框用)
 */
export function queryMySupplierForSelect(): API.Res<OrderSupplierVo[]> {
    return drpRequest.get('/mySupplier/queryMySupplierForSelect')
}

// 查询用户授权店铺
/**
 * 获取用户已启用、已授权、有权限的店铺
 */
export function listAuthShops(params: ListAuthShopsUsingGetParams): API.Res<GylErpShopInfo8[]> {
    return companyRequest.get('/sales/gylErpShopInfo/listAuthShops', { params })
}

// 查询用户授权店铺
/**
 * 查询用户授权店铺
 */
export function queryUserAuthShops(params: QueryUserAuthShopsUsingGetParams): API.Res<ShopVo[]> {
    return companyRequest.get('/shop/queryUserAuthShops', { params })
}

// 查询所有平台
/**
 *  查询商家店铺站点列表
 */
export function queryAllShopPlateFormForOrder(): API.Res<string[]> {
    return companyRequest.get('/shop/sites')
}

/**
 * 设置快递：打单使用(批量设置、批量清空、批量重算)
 */
export function batchSetExpress(data: ExpressParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchSetExpress', { data })
}

// 查询订单是否不同快递
/**
 * 校验是否可以设置快递
 */
export function judgeOrderIsSameExpress(data: ValidateExpressSettingParam): API.Res<boolean> {
    return companyRequest.post('/order/logistics/validateExpressSetting', { data })
}

// 重新计算运费
/**
 * 重算物流运费 (转换包含中文无法完全转换)
 */
export function recalculationFreight(data: RecalculationFreightParam): API.Res<any> {
    return companyRequest.post('/order/logistics/recalculateLogisticsShippingCost', { data })
}

/**
 * 重算物流运费V2 (转换包含中文无法完全转换)
 */
export function recalculateLogisticsShippingCostV2UsingPOST(data: RecalculationFreightParam): API.Res<any> {
    return companyRequest.post('/order/logistics/recalculateLogisticsShippingCostV2', { data })
}

/**
 * 审核推单（回显分销余额） 新接口，兼容审核订单 - erp控制是否需要异步
 * 根据返回值判断，有可能同步，有可能异步
 * @param {*} data
 * @returns
 */
/**
 * 审核或者推送订单V2(推动订单会显示分销余额) (转换包含中文无法完全转换)
 */
export function auditOrPushOrdersV2(data: AuditOrPushOrdersParam): API.Res<any> {
    return companyRequest.post('/order/operate/auditOrPushOrdersV2', { data })
}

/**
 * 查询分销资金推送结果 - 支付完成之后
 * @param {*} data
 * @returns
 */
/**
 * 查询分销资金推送结果
 */
export function pushResult(data: QueryOrderDto): API.Res<PushResultVo> {
    return payRequest.post('/order/pushResult', { data })
}

// 审核推单（回显分销余额） 新接口，兼容审核订单 ---- 异步接口
/**
 * 异步审核或者推送订单(推动订单会显示分销余额) (转换包含中文无法完全转换)
 */
export function sendAsyncAuditOrPushOrders(data: AuditOrPushOrdersParam): API.Res<any> {
    return companyRequest.post('/order/operate/asyncAuditOrPushOrders', { data })
}

// 审核推单（回显分销余额） 新接口，兼容审核订单 ---- 异步接口
/**
 * 按批次号获取推单结果(推单会显示分销余额) (转换包含中文无法完全转换)
 */
export function getPushOrderResultsByBatchNo(data: any): API.Res<AsyncProcessingResultVoAuditOrPushOrdersResult> {
    return companyRequest.post('/order/async/getPushOrderResultsByBatchNo', { data })
}

// 获取异步审核或者推送订单结果
/**
 * 获取异步审核或者推送订单结果(推单会显示分销余额) (转换包含中文无法完全转换)
 */
export function queryAsyncAuditOrPushOrders(data: any): API.Res<AsyncProcessingResultVoAuditOrPushOrdersResult> {
    return companyRequest.post('/order/operate/getAsyncAuditOrPushOrdersProcessingResult', { data })
}

// 获取异步任务结果
/**
 * 获取异步任务结果
 */
export function getAsyncTaskResult(data: CreateAsyncTaskResult): API.Res<AsyncProcessingResultVoObject> {
    return companyRequest.post('/async/task/getAsyncTaskResult', { data })
}

// 取消分销+订单
/**
 * 取消分销+
 */
export function cancelDisOrder(data: string[]): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/cancelDisOrder', { data })
}

// 强制指定供应商
/**
 * 强制指定供销商
 */
export function assignSupplier(data: AssignSupplierParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/assignSupplier', { data })
}

// 强制指定供应商
/**
 * 指定供销商
 */
export function assignSupplierForOrder(data: AssignSupplierForOrderParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/operate/assignSupplierForOrder', { data })
}

// 标签列表
/**
 * 查询标签列表
 */
export function orderTagList(params: OrderTagListUsingGetParams): API.Res<string[]> {
    return companyRequest.get('/order/orderTagList', { params })
}

// 普通订单转成分销+
/**
 * 转成分销+
 */
export function convertDisOrder(data: ConvertDisOrderParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/convertDisOrder', { data })
}

// 换商品-自营订单转成分销+
/**
 * 在换商品后使用的转成分销+接口
 */
export function convertDisOrderAfterExchangeGoods(data: ConvertDisOrderParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/operate/convertDisOrderAfterExchangeGoods', { data })
}

// 普通订单转成分销+
/**
 * 转成分销+
 */
export function convertAndSetSupDisOrder(data: ConvertAndSetSupDisOrderParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/convertAndSetSupDisOrderV2', { data })
}

// 一键指定供应商
/**
 * 批量转成分销+
 */
export function convertAndSetSupDisOrderV3(data: ConvertAndSetSupDisOrderV3Param): API.Res<ConvertAndSetSupDisOrderVo> {
    return companyRequest.post('/order/convertAndSetSupDisOrderV3', { data })
}

// 获取普通订单列表
/**
 * 普通订单列表
 */
export function getErpNormalOrders(data: DisInnerOrderListParam): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/innerOrder/getErpNormalOrders', { data })
}

// 获取全部订单列表
/**
 * 全部订单
 */
export function getAllOrders(data: InnerOrderListParam): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/order/getAllOrders', { data })
}

// 当前用户是否有该店铺的权限
/**
 * 当前用户是否有该店铺的权限
 */
export function isAuthShopApi(params: IsAuthShopUsingGetParams): API.Res<boolean> {
    return companyRequest.get('/shop/isAuthShop', { params })
}

// 收件人信息列表（包含搜索）
export function getReceiveAddressListUsingPOST(data) {
    return printerRequest.post('/receiveAddress/getReceiveAddressList', {
        data
    })
}
// 删除收件人地址
export function deleteAddress(params) {
    return printerRequest.get('/receiveAddress/deleteAddress', {
        params
    })
}
// 收件人信息保存或修改
export function saveAddressUsingPOST(data) {
    return printerRequest.post('/receiveAddress/saveAddress', {
        data
    })
}

// 揽收快超时
/**
 * 揽收快超时(根据类型区分)
 */
export function receiveTimeoutByType(data: ReceiveTimeOutParam): API.Res<string[]> {
    return companyRequest.post('/order/receiveTimeoutByType', { data })
}

// 订单删除商品
/**
 * 订单删除商品
 */
export function delGoods(data: DelGoodsParam): API.Res<object> {
    return companyRequest.post('/order/delGoods', { data })
}

// 订单拆单
/**
 * 订单拆单
 */
export function splitOrder(data: SplitOrderParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/splitOrder', { data })
}

// 获取换货商品
/**
 * 查询erp商品（自己或供应商）
 */
export function queryChangeGoods(data: QueryErpGoodsParam): API.Res<ErpGoodsVO[]> {
    return goodsRequest.post('/buyer/supplier/erpGoods/query', { data })
}

// 获取当前用户绑定店铺数量
/**
 * 获取店铺数量
 */
export function hasBindStoreApi(params: CountUsingGet1Params): API.Res<number> {
    return companyRequest.get('/shop/count', { params })
}

/**
 * 查询订单操作日志V2
 * @param {*} params
 * @returns
 */
/**
 * 查询订单操作日志
 */
export function fetchOrderActionV2(params: QueryOrderLogUsingGet1Params): API.Res<QueryOrderActionsVo> {
    return companyRequest.get('/order/queryOrderLog', { params })
}

// 批量撤回订单并获取批次号,包括退款逻辑
/**
 * 批量撤回订单并获取批次号 (转换包含中文无法完全转换)
 */
export function batchRevokeOrderAndGetBatchNo(data: OrderRevokeParam): API.Res<any> {
    return companyRequest.post('/order/operate/batchRevokeOrderAndGetBatchNo', { data })
}

// 标记结算
/**
 * 标记结算
 */
export function markApi(data: string[]): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/mark', { data })
}

// 取消结算
/**
 * 取消标记结算
 */
export function markCancelApi(data: string[]): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/markCancel', { data })
}

// 合并订单
export function autoMergeDisOrder() {
    return printerRequest.post('/nonDisOrder/autoMergeDisOrder')
}

// 合并订单
/**
 * 合并分销订单
 */
export function mergeDisOrder(data: string): API.Res<MergeDisOrderRsp[]> {
    return companyRequest.post('/order/mergeDisOrder', { data })
}

// 合并还原
/**
 * 取消合并分销订单
 */
export function cancelMergeDisOrder(data: string): API.Res<MergeDisOrderRsp[]> {
    return companyRequest.post('/order/cancelMergeDisOrder', { data })
}

// 根据订单号获取商品
/**
 * 根据订单号查询商品信息
 */
export function listGoodsInfo(data: DisInnerOrderListParam): API.Res<DisInnerOrderGoodsView[]> {
    return towerRequest.post('/innerOrder/listGoodsInfo', { data })
}

// 查询线上店铺SKU绑定关系
/**
 * 查询线上店铺SKU绑定关系
 */
export function querySkuBindMap(data: SkuBindMapQueryParam): API.Res<SkuBindMap> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/querySkuBindMap', { data })
}

// 将线上商品与erp商品进行绑定
/**
 * 将线上商品与erp商品进行绑定
 */
export function onlineItemBind(data: ShopItemBindParam[]): API.Res<OnlineItemBindVo[]> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/onlineItemBind', { data })
}

// 将线上商品与erp商品进行绑定
/**
 * 将线上商品与erp商品进行解绑
 */
export function onlineItemUnbind(data: ShopItemBindParam[]): API.Res<OnlineItemBindVo[]> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/onlineItemUnbinding', { data })
}

// 批量取消订单并获取退款批次号
/**
 * 批量取消订单并获取批次号 (转换包含中文无法完全转换)
 */
export function cancelOrderAndGetBatchNo(data: CancelOrderParam): API.Res<any> {
    return companyRequest.post('/order/operate/cancelOrderAndGetBatchNo', { data })
}

// 查询供应商商品信息
/**
 * 查询供应商商品信息
 */
export function querySupplierDrpGoods(data: OrderDrpGoodsVo): API.Res<OrderDrpGoodsInfo[]> {
    return goodsRequest.post('/goods/querySupplierDrpGoods', { data })
}

// 查询供应商商品信息
/**
 * 查询订单商品可配货库存
 */
export function queryOrderItemPickable(params: QueryOrderItemPickableUsingGetParams): API.Res<OrderItemPickableVo[]> {
    return companyRequest.get('/order/queryOrderItemPickable', { params })
}

// 获取线上商品链接
/**
 * 获取线上商品链接
 */
export function queryOrderItemLink(data: ItemLinkParam): API.Res<Record<string, object>> {
    return companyRequest.post('/order/getItemLink', { data })
}

// 获取订单金额拆分规则
/**
 * 设置订单金额拆分规则
 */
export function saveOrderAmountSplitRules(data: OrderAmountSplitRulesParam): API.Res<SaveOrderAmountSplitRulesVo> {
    return companyRequest.post('/order/setting/saveOrderAmountSplitRules', { data })
}

// 获取订单金额拆分规则
export function getOrderAmountSplitRules() {
    return companyRequest.get('/order/setting/getOrderAmountSplitRules')
}

// 一键拆分(拆分订单并转正常)
/**
 * 一键拆分(拆分订单并转正常)
 */
export function singleSplitOrderApiv2(data: SingleSplitOrderV2Param): API.Res<ErpDisOrderRsp> {
    return companyRequest.post('/order/operate/oneClickSplitOrder', { data })
}

// 根据线上订单号查询商品信息
/**
 * 根据订单号查询商品信息
 */
export function listGoodsInfoApi(data: DisInnerOrderListParam): API.Res<DisInnerOrderGoodsView[]> {
    return towerRequest.post('/innerOrder/listGoodsInfo', { data })
}

// 新增/删除商家自定义标签
/**
 * 新增/删除商家自定义标签
 */
export function updateCompanyTag(data: UpdateCompanyTagParam): API.Res<ErpDisOrderRsp> {
    return companyRequest.post('/order/updateCompanyTag', { data })
}

// 批量设置订单标签
/**
 * 批量设置订单标签
 */
export function batchSetOrderTag(data: SetOrderTagParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchSetOrderTag', { data })
}

// 批量设置订单备注/旗帜
/**
 * 批量设置订单备注/旗帜
 */
export function batchSetOrderRemarkAndFlag(data: SetOrderFlagParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchSetOrderRemarkAndFlag', { data })
}

// 批量设置订单备注/旗帜 (大批量)
/**
 * 异步批量设置订单备注/旗帜（提供给打单转待审核时使用）
 */
export function asyncBatchSetOrderRemarkAndFlag(data: SetOrderFlagParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/asyncBatchSetOrderRemarkAndFlag', { data })
}

// 批量还原已取消订单
/**
 * 批量还原已取消订单
 */
export function unCancelOrder(data: string): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/unCancelOrder', { data })
}

// 获取近三天上传发货失败数量
/**
 * 获取近三天上传发货失败数量
 */
export function getUpSendFailedCount(data: DisInnerOrderListParam): API.Res<number> {
    return towerRequest.post('/innerOrder/getUpSendFailedCount', { data })
}

// 批量还原拆分订单
/**
 * 还原拆分订单
 */
export function revertSplitOrder(data: string): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/revertSplitOrder', { data })
}

// 是否显示查看供销商库存列表
/**
 * 是否显示查看供销商库存列表
 */
export function queryDisplayStock(): API.Res<boolean> {
    return goodsRequest.get('/buyer/supplier/queryDisplayStock')
}

// 查询商品在供应商中是否存在
/**
 * 查询商品在供应商中是否存在
 */
export function queryErpItemCodeExists(data: ErpSupplierItemParam[]): API.Res<ErpSupplierItemVo[]> {
    return goodsRequest.post('/buyer/supplier/erpGoods/queryErpItemCodeExists', { data })
}

// 获取京东订单解密header信息
/**
 * swagger找不到此接口
 */
export function getJosHeaderApi(data) {
    return towerRequest.post('/innerOrder/getJosHeader ', {
        data
    })
}

// 获取P50
/**
 * swagger找不到此接口
 */
export function getP50Api(data) {
    return towerRequest.post('/innerOrder/getP50 ', {
        data
    })
}

// 获取ShopSessionUid
/**
 * swagger找不到此接口
 */
export function getShopSessionUidApi(data) {
    return towerRequest.post('/innerOrder/getShopSessionUid ', {
        data
    })
}

// 后端 单个解密
/**
 * swagger找不到此接口
 */
export function decryptionApi(data) {
    return towerRequest.post('/innerOrder/decryption ', {
        data
    })
}

// 后端 单个解密 v2
/**
 * 解密V2
 */
export function decryptionApiV2(data: OrderDecryptionParam): API.Res<DecryptionVo> {
    return towerRequest.post('/innerOrder/decryptionV2', { data })
}

// 后端 批量脱敏
/**
 * swagger找不到此接口
 */
export function batchFuzzyApi(data) {
    return towerRequest.post('/innerOrder/batchFuzzy ', {
        data
    })
}

// 获取解密查询一次性token
/**
 * swagger找不到此接口
 */
export function getSecTokenApi(data) {
    return towerRequest.post('/innerOrder/getSecToken ', {
        data
    })
}

// 获取解密查询初始化入参
/**
 * swagger找不到此接口
 */
export function getDecDataApi(data) {
    return towerRequest.post('/innerOrder/getDecData ', {
        data
    })
}

// 回传解密日志
/**
 * swagger找不到此接口
 */
export function decryptionLogApi(data) {
    return towerRequest.post('/innerOrder/decryptionLog ', {
        data
    })
}

// 手工下单 创建订单
/**
 * 创建订单(创建分销判断策略)
 */
export function createForDisOrder(data: GylOrder[]): API.Res<OrderCreateVo[]> {
    return companyRequest.post('/order/createForDisOrder', { data })
}

// 手工下单 创建订单 忽略权限
/**
 * 创建订单(创建分销判断策略)
 */
export function createForDisOrderIgnoreAuth(data: GylOrder[]): API.Res<OrderCreateVo[]> {
    return companyRequest.post('/order/createForDisOrder', { data })
}

// 手工下单 创建订单（适用于打单）
/**
 * 创建订单
 */
export function createOrderForPrint(data: GylOrder[]): API.Res<OrderCreateVo[]> {
    return companyRequest.post('/order/create', { data })
}

// 批量添加赠品
/**
 * 批量添加赠品
 */
export function batchAddGift(data: string): API.Res<BatchAddGiftVo> {
    return companyRequest.post('/order/batchAddGift', { data })
}

// 打单发货：支持手工拉取店铺订单通过订单号
/**
 * 根据线上订单号下载订单
 */
export function manuallyPullStoreOrdersBySoIds(data: SyncOrdersBySoIdsParam): API.Res<DownloadOrderVo> {
    return companyRequest.post('/order/operate/syncOrdersBySoIds', { data })
}

// 打单发货：支持手工拉取店铺订单通过时间
/**
 * 根据时间范围下载订单
 */
export function manuallyPullStoreOrdersByTime(data: SyncOrdersByTimeRangeParam): API.Res<DownloadOrderVo> {
    return companyRequest.post('/order/operate/syncOrdersByTimeRange', { data })
}

// 打单发货：支持手工拉取店铺订单通过时间_新版适应轮询接口
/**
 * 根据时间范围下载订单(异步)
 */
export function asyncDownloadOrdersByTime(data: SyncOrdersByTimeRangeParam): API.Res<CreateAsyncTaskResult> {
    return companyRequest.post('/order/operate/asyncDownloadOrdersByTime', { data })
}

// 查询订单的物流轨迹 V2
export function queryLogisticsTrack(params) {
    return printerRequest.get('/logistics/print/queryLogisticsTrack', {
        params
    })
}
// 重算分销运费
export function recalculationFreightPrint(data) {
    return printerRequest.post('/saleOutOrder/recalculationFreight', {
        data
    })
}

// 订单换货(多换一)
/**
 * 订单换货(多换一)
 */
export function exchangeGoodsByMultiple(data: ErpExchangeGoodsByMultipleParam): API.Res<ExchangeGoodsByMultipleVo> {
    return companyRequest.post('/order/exchangeGoodsByMultiple', { data })
}

// 批量拆分组合装
/**
 * 批量拆分组合装
 */
export function batchSplitCombine(data: BatchSplitCombineParam): API.Res<BatchSplitCombineVo> {
    return companyRequest.post('/order/batchSplitCombine', { data })
}

// 单个拆分组合装
/**
 * 拆分组合装
 */
export function splitCombine(data: SplitCombineParam): API.Res<SplitCombineVo> {
    return companyRequest.post('/order/splitCombine', { data })
}

// 自动审单和自动合并配置查询
export function getAuditAndMergeConfig(params) {
    return printerRequest.get('/nonDisOrder/getAuditAndMergeConfig', {
        params
    })
}
/*
 * 自动审单和自动合并设置
 * autoAudit-自动审核订单
 * ignoreMessage-有买家留言的不自动审核
 * ignoreRemark-有卖家备注的不自动审核
 * autoMerge-自动合并订单
 * */
export function saveAuditAndMergeConfig(data) {
    return printerRequest.post('/nonDisOrder/saveAuditAndMergeConfig', {
        data
    })
}

// 查询分销商自己的订单的物流费用
/**
 * 查询订单的物流费用(分销商自己的物流)
 */
export function queryOrderLogisticsFreight(
    params: QueryOrderLogisticsFreightUsingGet1Params
): API.Res<OrderFreightQueryVo[]> {
    return companyRequest.get('/order/queryOrderLogisticsFreight', { params })
}

// 查询订单对应供应商的物流费用
/**
 * 查询订单的物流费用(供应商物流)
 */
export function queryOrderSupLogisticsFreights(data: OrderSupLogisticsParam): API.Res<SupplierLogisticsVo[]> {
    return companyRequest.post('/order/queryOrderSupLogisticsFreights', { data })
}

// 查询订单对应供应商的物流费用(无不允许分销商配置快递限制)
/**
 * 查询订单的物流费用(供应商物流)
 */
export function querySingleOrderSupLogisticsFreights(data: OrderSupLogisticsParam): API.Res<SupplierLogisticsVo[]> {
    return companyRequest.post('/order/list/querySingleOrderSupLogisticsFreights', { data })
}

/**
 * 设置快递:分销订单使用
 */
export function batchSetLogistics(data: DisOrderLogisticsParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchSetLogistics', { data })
}

// 获取发货仓库列表
/**
 * 获取仓库列表
 */
export function getWarehouses(): API.Res<Record<string, string>> {
    return companyRequest.get('/wms/getWarehouses')
}

//  修改发货仓
export function updateDeliveryWarehouse(data) {
    return printerRequest.post('/nonDisOrder/updateDeliveryWarehouse', {
        data
    })
}

// 查询分销充值收入账户接口
export const getSellerAccounts = params => printerRequest.get('/nonDisOrder/getSellerAccounts', { params })

// 分销付款余额不足充值接口
export const disRecharge = data => printerRequest.post('/nonDisOrder/disRecharge', { data })

// 非分销+订单 分销付款
export const payDisOrder = data => printerRequest.post('/nonDisOrder/payDisOrder', { data })

// 查询用户线下备注列表
/**
 * 查询用户线下备注列表
 */
export function getOrderNotes(): API.Res<QueryErpOrderNotesVo> {
    return companyRequest.get('/order/queryErpOrderNotes')
}

// 保存用户线下备注列表
/**
 * 保存用户线下备注列表
 */
export function saveOrderNotes(data: SaveErpOrderNotesParam): API.Res<SaveErpOrderNotesVo> {
    return companyRequest.post('/order/saveErpOrderNotes', { data })
}

//  批量保存订单的线下备注
/**
 * 批量保存订单的线下备注
 */
export function batchSetOrderNotes(data: BatchSetOrderNotesParam): API.Res<BatchSetOrderNotesVo> {
    return companyRequest.post('/order/batchSetOrderNotes', { data })
}

//  获取拆分规则
/**
 * 查询订单拆分规则
 */
export function queryOrderSplitRules(): API.Res<QueryOrderSplitRulesVo> {
    return companyRequest.get('/order/queryOrderSplitRules')
}

//  拆分订单
/**
 * 根据规则拆分订单
 */
export function splitOrdersAccordingToRules(
    data: SplitOrdersAccordingToRulesParam
): API.Res<SplitOrdersAccordingToRulesVo> {
    return companyRequest.post('/order/splitOrdersAccordingToRules', { data })
}

// 查询亏损订单
/**
 * 查询亏损订单列表或者亏损订单数量
 */
export function queryUnprofitableOrder(params: QueryUnprofitableOrderUsingGet1Params): API.Res<ErpDisOrder[]> {
    return companyRequest.get('/order/list/queryUnprofitableOrder', { params })
}

// 查询低于管控价格的订单
/**
 * 查询低于管控价格的订单V2
 */
export function queryOrdersBelowControlPrice(data: PriceDropQueryParameters): API.Res<QueryOrdersBelowControlPriceVo> {
    return companyRequest.post('/order/list/queryOrdersBelowControlPriceV2', { data })
}

// 锁定订单
/**
 * 锁定订单
 */
export function lockTheOrder(data: LockTheOrderParam): API.Res<LockAndUnlockTheOrderVo> {
    return companyRequest.post('/order/lockTheOrder', { data })
}

// 解锁订单
/**
 * 解锁订单
 */
export function unlockTheOrder(data: UnlockTheOrderParam): API.Res<LockAndUnlockTheOrderVo> {
    return companyRequest.post('/order/unlockTheOrder', { data })
}

// 更新订单亏损配置
/**
 * 设置订单可能亏损配置
 */
export function updateLossMaking(data: OrderLossMakingConfig): API.Res<boolean> {
    return companyRequest.post('/order/config/updateLossMaking', { data })
}

// 查询订单亏损配置
/**
 * 查询订单可能亏损配置
 */
export function queryLossMaking(): API.Res<OrderLossMakingConfig> {
    return companyRequest.get('/order/config/queryLossMaking')
}

// 查询快递的投递状态
/**
 * 查询快递的投递状态
 */
export function queryDeliveryStatusOfThePackage(data: QueryDeliveryStatusParam): API.Res<ExpressDeliveryStatusVo> {
    return companyRequest.post('/order/list/queryDeliveryStatusOfThePackage', { data })
}

// 查询快递的投递状态 比queryDeliveryStatusOfThePackage 优化过的，少了很多字段
/**
 * 查询快递的投递状态
 */
export function queryExpressDeliverySuspensionStatus(
    data: QueryExpressDeliverySuspensionStatusParam
): API.Res<ExpressDeliverySuspensionStatusVo> {
    return companyRequest.post('/order/list/queryExpressDeliverySuspensionStatus', { data })
}

// 换商品
/**
 * 订单批量换货
 */
export function batchExchangeGoods(data: BatchExchangeGoodsParam): API.Res<BatchExchangeGoodsVo> {
    return companyRequest.post('/order/operate/batchExchangeGoods', { data })
}

// 微信公众号 扫码关注的临时二维码
export function getWechatCode() {
    return companyRequest.get('/wechat/officialAccount/codeUrl')
}

// 根据商品编码查询订单ID
/**
 * 根据商品编码查询订单ID
 */
export function queryOrderIdByItemCode(data: QueryOrderIdByItemCodeParam): API.Res<QueryOrderIdByItemCodeVo> {
    return companyRequest.post('/order/list/queryOrderIdByItemCode', { data })
}

// 查询供应商sku行数
/**
 * 查询供应商sku行数限制
 */
export function querySupplierSkuLimit(params: QuerySupplierSkuLimitUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/supplier/goods/querySupplierSkuLimit', { params })
}

// 订单商品定价策略
/**
 * 订单商品定价策略
 */
export function queryOrderProductPricingStrategy(
    data: OrderProductPricingStrategyParam
): API.Res<OrderProductPricingStrategyVo> {
    return companyRequest.post('/order/goods/orderProductPricingStrategy', { data })
}

// 分销商向供应商发起结算使用
/**
 * 查询分销待结算的订单（分销商向供应商发起结算使用）
 */
export function queryPendingSettlementChannelOrders(
    data: QueryPendingSettlementOrders
): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/settlement/queryPendingSettlementChannelOrders', { data })
}

// 供应商向分销商发起结算使用
/**
 * 查询供销待结算的订单（供应商向分销商发起结算使用）
 */
export function queryPendingSettlementSupOrders(data: QueryPendingSettlementOrders): API.Res<DisInnerOrderListView[]> {
    return towerRequest.post('/settlement/queryPendingSettlementSupOrders', { data })
}

// 供销结算单生成
/**
 * 供销结算单生成
 */
export function generateSupSettlementDocument(data: GenerateSupSettlementParam): API.Res<string> {
    return companyRequest.post('/sup/settlement/generateSupSettlementDocument', { data })
}

// 分销结算单生成
/**
 * 分销结算单生成
 */
export function generateChannelSettlementDocument(data: GenerateSupSettlementParam): API.Res<string> {
    return companyRequest.post('/orderChannelSettlement/generateChannelSettlementDocument', { data })
}

// 订单金额
/**
 * 订单金额
 */
export function orderChannelSettlementAmount(data: ChannelSettlementAmountParam): API.Res<ErpDisOrderAmt[]> {
    return companyRequest.post('/orderChannelSettlement/amount', { data })
}

// 查询结算单改价日志
/**
 * 查询结算单改价日志
 */
export function queryPriceChangeLog(
    params: QueryPriceChangeLogUsingGetParams
): API.Res<OrderSettlementPriceChangeLog[]> {
    return companyRequest.get('/orderSettlementPriceChangeLog/queryPriceChangeLog', { params })
}

// 查询结算单改价日志
/**
 * 跳转后查询订单号
 */
export function getOrderIdsAfterRedirect(params: GetOrderIdsAfterRedirectUsingGetParams): API.Res<string[]> {
    return companyRequest.get('/order/getOrderIdsAfterRedirect', { params })
}

// 查询异常数
/**
 * 获取供货价异常的订单数量
 */
export function queryFilterNegative(data: GenerateSupSettlementParam): API.Res<number> {
    return companyRequest.post('/sup/settlement/getAbnormalSupplyPriceOrderCount', { data })
}

// 供销商查询我的分销商是否开通允许供应商拆单的数量
/**
 * 供销商查询我的分销商是否开通允许供应商拆单的数量
 */
export function queryAllowSplitOrderNum(): API.Res<AllowSplitOrderNumVo> {
    return drpRequest.get('/partner/supplier/queryAllowSplitOrderNum')
}

// 查询订单配置
/**
 * 查询订单配置
 */
export function queryOrderConfig(): API.Res<OrderConfigVo> {
    return companyRequest.get('/order/config/queryOrderConfig')
}

// 修改订单配置
/**
 * 修改订单配置
 */
export function editOrderConfig(data: EditOrderConfigParam): API.Res<boolean> {
    return companyRequest.post('/order/config/editOrderConfig', { data })
}

// 是否有发货快超时的订单
/**
 * 是否有发货快超时的订单
 */
export function hasFastApproachingShippingDeadlineOrders(): API.Res<boolean> {
    return companyRequest.get('/order/statistics/hasFastApproachingShippingDeadlineOrders')
}

// 通过商品编码获取供应商
/**
 * 根据商品编码+分销判断策略查询供应商
 */
export function querySupplierByItemCode(data: ItemCodesParam): API.Res<ItemCodesSupplierInfoVo[]> {
    return towerDrpRequest.post('/supplier/item/querySupplierInfoByItemCode', { data })
}

/**
 * 催供应商发货打标
 * @param {*} data
 * @returns
 */
/**
 * 催供应商发货打标
 */
export function urgeDispatchGoods(data: UrgeDispatchGoodsParam): API.Res<UrgeDispatchGoodsVo> {
    return companyRequest.post('/order/urgeDispatchGoods', { data })
}

/**
 * 查询分销商催发货列表
 * @param {*} data
 * @returns
 */
/**
 * 查询分销商催发货列表
 */
export function listChannelUrgeSend(data: ListUrgeSendParam): API.Res<UrgeSendVo> {
    return companyRequest.post('/order/listChannelUrgeSend', { data })
}

/**
 * 查询已催供应商发货列表
 * @param {*} data
 * @returns
 */
/**
 * 查询已催供应商发货列表
 */
export function listSupplierAlreadyUrged(data: ListUrgeSendParam): API.Res<UrgeSendVo> {
    return companyRequest.post('/order/listSupplierAlreadyUrged', { data })
}

/** 关闭待合并订单转异常开关 */
/**
 * 关闭待合并订单转异常开关
 */
export function closeMergeOrderToException(): API.Res<boolean> {
    return companyRequest.get('/order/config/closeMergeOrderToException')
}

/**
 * 订单明细分销扩展信息(供应商库存不足、销售未授权商品等信息)
 * @param {*} data
 * @returns
 */
/**
 * 订单明细分销扩展信息(供应商库存不足、销售未授权商品等信息)
 */
export function getOrderItemDrpExtend(data: OrderItemDrpExtendParam): API.Res<OrderItemDrpExtendVo> {
    return companyRequest.post('/order/list/getOrderItemDrpExtend', { data })
}

/** 手工下单并校验起采金额 */
/**
 * 手工下单并校验起采金额
 */
export function manualOrderPlacementAndMinimumAmountCheck(data: GylOrder[]): API.Res<OrderCreateVo[]> {
    return companyRequest.post('/order/manualOrderPlacementAndMinimumAmountCheck', { data })
}

// 订单批量删除商品
/**
 * 订单删除商品
 */
export function batchDelGoods(data: BatchDelGoodsParam): API.Res<object> {
    return companyRequest.post('/order/batchDelGoods', { data })
}

/** 校验起采金额 */
/**
 * 校验起采金额 (转换包含中文无法完全转换)
 */
export function validatePurchasePrice(data: any): API.Res<any> {
    return companyRequest.post('/order/goods/validatePurchasePrice', { data })
}

/** 查询被拆分的订单号 */
/**
 * 查询拆分后订单号
 */
export function getSplitOrderId(params: GetSplitOrderIdUsingGetParams): API.Res<string[]> {
    return companyRequest.get('/order/getSplitOrderId', { params })
}
/**
 * 查询商品存在多个供应商的异常信息
 */
export function queryMultiSuppliersInfoUsingGET(
    params: QueryMultiSuppliersInfoUsingGetParams
): API.Res<ItemMultiSupplierInfoVo> {
    return companyRequest.get('/order/queryMultiSuppliersInfo', { params })
}

/**
 * 获取免费商家卡控弹框
 * @param params
 * @returns
 */
export function queryCompanyFreeLimitTip(params) {
    return towerPrinterRequest.get('/company/free/limit/tip', {
        params
    })
}

/**
 * 转正常单(忽略特定异常)
 */
export function batchTransformNormalIgnoreSpecialUsingPOST1(data: string[]): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/batchTransformNormalIgnoreSpecial', { data })
}

/** 查询物流和运费 */
export function queryLogisticsAndFreightUsingPOST(
    data: QueryLogisticsAndFreightParam
): API.Res<QueryLogisticsAndFreightVo> {
    return companyRequest.post('/order/logistics/queryLogisticsAndFreight', { data })
}

/**
 * 设置或绑定快递（小程序使用，如果没有这个快递就直接绑定）
 */
export function batchSetOrBindingExpressV2UsingPOST(data: BatchSetOrBindingExpressParam): API.Res<ErpDisOrderRsp[]> {
    return companyRequest.post('/order/operate/batchSetOrBindingExpressV2', { data })
}

/**
 * 查询物流和运费（异步）
 */
export function asyncQueryLogisticsAndFreight(
    data: QueryLogisticsAndFreightParam
): API.Res<AsyncQueryLogisticsAndFreightVo> {
    return companyRequest.post('/order/logistics/asyncQueryLogisticsAndFreight', { data })
}

/**
 * 获取异步查询物流和运费结果
 */
export function getAsyncQueryLogisticsAndFreightResult(
    data: AsyncResultParams
): API.Res<AsyncProcessingResultVoQueryLogisticsAndFreightVo> {
    return companyRequest.post('/order/async/getAsyncQueryLogisticsAndFreightResult', { data })
}
